import { useContext } from "react"
import { CupomEstabelecimentoFornecedorContext } from "./CupomEstabelecimentoFornecedorContext"

export function useCupomEstabelecimentoFornecedorContext() {
    return useContext(CupomEstabelecimentoFornecedorContext)
}
